module.exports = __webpack_public_path__ + "static/media/摄像头.1f49e5b5.jpg";